import * as React from "react";

import {
  BROKER_FIELD_DESC_CLASS,
  BROKER_ALERT_TITLE_CLASS,
} from "@/components/Broker/brokerAlertUi";
import { TradeFilterSelectFullWidth } from "@/components/trade-filter-selects";
import { Field, FieldLabel } from "@/components/ui/field";

export type PnlMilestoneFieldSelectProps = {
  id: string;
  label: string;
  value: string;
  onValueChange: (value: string) => void;
  options: { value: string; label: string }[];
  disabled?: boolean;
};

export function PnlMilestoneFieldSelect({
  id,
  label,
  value,
  onValueChange,
  options,
  disabled = false,
}: PnlMilestoneFieldSelectProps): React.ReactElement {
  return (
    <Field className="min-w-0 flex-1 gap-2" data-pnl-milestone-field="">
      <FieldLabel htmlFor={id} className={BROKER_ALERT_TITLE_CLASS}>
        {label}
      </FieldLabel>
      <TradeFilterSelectFullWidth
        id={id}
        value={value}
        onValueChange={onValueChange}
        options={options}
        disabled={disabled}
      />
    </Field>
  );
}

export function PnlMilestoneFieldHint({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}): React.ReactElement {
  return <p className={`${BROKER_FIELD_DESC_CLASS} m-0 ${className ?? ""}`}>{children}</p>;
}
